import * as React from "react";
import { TrendingUp, Target, CircleCheck, MousePointerClick } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter } from "@/components/ui/card";
const features = ["Sky-high taxes: Nation-leading property taxes and heavy overall burdens crushing affordability.", "Governmental policies: Ongoing fiscal struggles and governance frustrations pushing residents away.", "Brutal winters: Freezing cold and snow sending many to sunnier, warmer states.", "If you stay much longer, you might just be the last one turning off the lights."];
export default function VisibilityTraffic() {
  return <section data-section-id="228387" id="the-case-for-relocation" className="bg-background py-20 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="grid grid-cols-1 items-center gap-16 lg:grid-cols-2 lg:gap-24">
          
          {}
          <div className="flex flex-col justify-center">
            <div className="mb-6 inline-flex w-fit items-center gap-2 rounded-lg bg-primary/10 px-3 py-1 text-sm font-medium text-primary">
              <TrendingUp className="size-4" />
              <span className="font-default">Migration Trends</span>
            </div>
            <h2 className="font-serif text-4xl font-bold tracking-tight text-foreground sm:text-5xl mb-6">
              Why Are So Many People Leaving Illinois Right Now?
            </h2>
            <p className="mb-8 max-w-xl text-lg leading-relaxed text-muted-foreground font-default">
              The data doesn't lie. Thousands of residents are choosing to relocate every month, seeking relief from the mounting pressures of life in the Land of Lincoln. Understanding these drivers is the first step in planning your own successful transition to a better quality of life.
            </p>
            
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center">
              <div className="flex items-center gap-3 rounded-sm border border-border/10 bg-card/30 px-4 py-3 shadow-sm">
                <MousePointerClick className="size-5 text-primary" />
                <span className="font-default text-sm font-semibold text-foreground">Tax Relief Experts</span>
              </div>
              <div className="flex items-center gap-3 rounded-sm border border-border/10 bg-card/30 px-4 py-3 shadow-sm">
                <Target className="size-5 text-primary" />
                <span className="font-default text-sm font-semibold text-foreground">Relocation Strategy</span>
              </div>
            </div>
          </div>

          {}
          <div className="relative group mx-auto w-full max-w-md lg:max-w-none lg:mx-0">
            {}
            <div className="absolute -inset-1 rounded-md bg-gradient-to-br from-primary/30 to-transparent opacity-0 blur-xl transition-opacity duration-500 group-hover:opacity-100" aria-hidden="true" />
            
            <Card className="relative h-full overflow-hidden border-border/10 bg-card transition-all duration-300 hover:border-primary/50 hover:shadow-2xl">
              <CardHeader className="pb-6 pt-8 px-8">
                <div className="mb-6 flex items-start justify-between">
                  <div className="rounded-md bg-primary/20 p-3">
                    <Target className="size-6 text-primary" />
                  </div>
                  <span className="inline-flex items-center rounded-lg bg-accent px-3 py-1 text-xs font-semibold tracking-wide text-primary">
                    CRITICAL FACTORS
                  </span>
                </div>
                <CardTitle className="font-serif text-2xl font-bold text-foreground mb-3">
                  The Exit Framework
                </CardTitle>
                <CardDescription className="text-base leading-relaxed text-muted-foreground font-default">
                  Identify the primary reasons driving your move and build a roadmap to escape the Illinois burden.
                </CardDescription>
              </CardHeader>
              
              <CardContent className="px-8 pb-8">
                <div className="mb-8 flex items-baseline gap-2 border-b border-border/10 pb-8">
                  <span className="font-serif text-5xl font-bold tracking-tight text-foreground">
                    Phase 1
                  </span>
                  <span className="text-sm font-medium text-muted-foreground font-default">
                    / Assessment
                  </span>
                </div>
                
                <ul className="space-y-4">
                  {features.map((feature, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                      <CircleCheck className="mt-0.5 size-5 shrink-0 text-primary" />
                      <span className={`text-sm font-medium ${i === 3 ? 'italic text-muted-foreground' : 'text-card-foreground/90'} font-default`}>
                        {feature}
                      </span>
                    </li>)}
                </ul>
              </CardContent>
              
              <CardFooter className="px-8 pb-8 pt-0">
                <Link to="#" className="w-full">
                  <Button className="w-full h-12 text-base font-bold shadow-md transition-transform active:scale-[0.98] bg-red-600 text-white hover:bg-blue-700 rounded-lg font-default border-none">
                    Start Your Exit Plan
                  </Button>
                </Link>
              </CardFooter>
            </Card>
          </div>

        </div>
      </div>
    </section>;
}